module.exports = __webpack_public_path__ + "static/media/slide_two.3a3ffd36.jpg";